export const DEFAULT_PAGINATION_SIZE_TENANT = 10;
export const DEFAULT_PAGINATION_SIZE_GET_NODE_ADMINISTERS_CROSS_USES =
  DEFAULT_PAGINATION_SIZE_TENANT;
export const DEFAULT_PAGINATION_SIZE_GET_NODE_PERSON_DOMAIN = 50;
export const DEFAULT_INITIAL_CURRENT_PAGE = 0;
